import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import state from "./state";
import mutations from "./mutations";
import getters from "./getters";
import actions from "./actions";

import categories from "./modules/categories";
import documents from "./modules/documents";

export default new Vuex.Store({
    modules: {
        categories,
        documents
    },

    state, mutations, getters, actions
});
